module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services08-ade69aa528a53f501735f292b40d7624.jpg";